/** @jsxImportSource @emotion/react */
import { Table, Typography, useTheme } from '@quickbit/qb-design-system';
import { flattenJson } from 'utils/flattenJson';

export const AffiliateVerificationTable = ({
  verification,
}: {
  verification: Record<string, any>;
}) => {
  const flattenedVerification = flattenJson(verification);
  const { spacing } = useTheme();

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: spacing.xxs }}>
      <Typography variant="heading2">Verification</Typography>
      <Table
        headers={[
          { label: 'Key', cellKey: 'key', sort: false },
          { label: 'Value', cellKey: 'value', sort: false },
        ]}
        rows={flattenedVerification.map(({ key, value, depth }) => ({
          value: {
            key: (
              <div style={{ paddingLeft: `${depth * 32}px` }}>
                <Typography variant="bodyBold">{key}</Typography>
              </div>
            ),
            value: <Typography>{value}</Typography>,
          },
        }))}
      />
    </div>
  );
};
